<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <b-card
                    no-body
                >
                    <b-card-header>
                        <b-card-title>
                            <b>Payment</b> Result
                        </b-card-title>
                    </b-card-header>
                    <b-alert show :variant="this.replyCd === '0000' ? 'success' : 'warning'" class="text-center">
                        <div class="alert-body">
                            <p>
                                <b>
                                    {{ message }} ({{ replyCd }})
                                </b>
                            </p>
                            <p>
                                감사합니다.
                            </p>
                        </div>
                    </b-alert>
                </b-card>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            replyCd: '',
            replyMsg: ''
        }
    },
    computed: {
        message () {
            if (this.replyCd === '0000') {
                return '정상적으로 결제되었습니다.'
            } else {
                return this.replyMsg
            }
        }
    },
    mounted () {
        this.replyCd = this.$route.query.replyCd
        this.replyMsg = this.$route.query.replyMsg
        if (window.opener) {
            opener.AllatPay_Closechk_End()
            opener.location.reload()
        }
    }
}
</script>

<style>

</style>
